'use strict';

const _=require('pulsar-utils/dist-es6/_');let

PseudoGroup=class PseudoGroup{
constructor({name='--',directPersons=[],children=[],parentGroupName,parentGroupId}={}){
this._name=name;
this._directPersons=directPersons;
this._children=children;
this._parentGroupName=parentGroupName;
this._parentGroupId=parentGroupId;

this._colSpan=1;
}

get name(){
return this._name;
}

get parentGroupName(){
return this._parentGroupName;
}

get parentGroupId(){
return this._parentGroupId;
}

get colSpan(){
return this._colSpan;
}

set colSpan(colSpan){
this._colSpan=colSpan;
}

get directPersons(){
return this._directPersons;
}

get children(){
return this._children;
}};


module.exports=PseudoGroup;
//# sourceMappingURL=pseudoGroup.js.map
